export default __webpack_public_path__ + "static/logo-type-2aaa70d1de4bdd1941b25d1ba479d6fb.svg";